import React, { useEffect, useRef, useState } from "react";
let scriptPromise;
const loadScript = url => {
  if (window.turnstile) return Promise.resolve();
  if (!scriptPromise) scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script"); script.src = url; script.async = true; script.defer = true;
    script.onload = resolve; script.onerror = () => { scriptPromise = null; reject(new Error("Verification could not load")); }; document.head.appendChild(script);
  });
  return scriptPromise;
};
export const TurnstileChallenge = ({ config, action, reset, onToken }) => {
  const container = useRef(null), callback = useRef(onToken); callback.current = onToken;
  const [error, setError] = useState("");
  useEffect(() => {
    let disposed = false, widget;
    callback.current(""); setError("");
    if (!config?.available) return;
    // Preview/disabled mode: no widget — set a bypass token so the submit button enables.
    if (config.mode === "disabled") {
      callback.current("PREVIEW_BYPASS");
      return;
    }
    loadScript(config.script_url).then(() => {
      if (disposed || !container.current) return;
      widget = window.turnstile.render(container.current, { sitekey: config.site_key, action, size: "compact", theme: "light",
        callback: token => callback.current(token), "expired-callback": () => callback.current(""),
        "error-callback": () => { callback.current(""); setError("Verification failed. Close and reopen this form to retry."); } });
    }).catch(() => setError("Verification could not load. Please retry shortly."));
    return () => { disposed = true; if (widget !== undefined && window.turnstile) window.turnstile.remove(widget); };
  }, [config, action, reset]);
  // Disabled mode renders nothing — no widget, no error message.
  if (config?.mode === "disabled") return null;
  return <div className="min-w-0" data-testid={`turnstile-${action}`}><div ref={container} />{error && <p role="alert" className="text-xs text-red-700" data-testid={`turnstile-error-${action}`}>{error}</p>}</div>;
};